"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { checkFiles } from "@/lib/files";
import { clearHandedOffFiles, peekHandedOffFiles } from "@/lib/handoff";
import type { Tool } from "@/lib/tools";

/** A tool page's original files, starting with any handed over from the home
 *  page or another tool. `notices` explains files that couldn't be taken. */
export function useToolFiles(tool) {
  const $ = _c(7);
  let t0;
  if ($[0] !== tool.accepts || $[1] !== tool.maxFiles) {
    t0 = () => checkFiles(peekHandedOffFiles(), {
      accepts: tool.accepts,
      maxFiles: tool.maxFiles
    });
    $[0] = tool.accepts;
    $[1] = tool.maxFiles;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const [initial] = useState(t0);
  const [files, setFiles] = useState(initial.accepted);
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  useEffect(_temp, t1);
  let t2;
  if ($[4] !== files || $[5] !== initial.problems) {
    t2 = {
      files,
      setFiles,
      notices: initial.problems
    };
    $[4] = files;
    $[5] = initial.problems;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}
function _temp() {
  return clearHandedOffFiles();
}